import { useMutation } from '@tanstack/react-query';
import type { branch } from '@/types';
import type { ScmProviderId } from '@/types/scm-provider';
import { scmPost } from './scmClient';

interface branchesRes {
  success: boolean;
  statusCode: number;
  message: string;
  data: {
    count: number;
    value: branch[];
  };
}

export const getBranchesDetails = (
  provider: ScmProviderId,
  body: {
    organization: string;
    project: string;
    repositoryId: string;
  },
  requesterToken: { patToken: string },
): Promise<branchesRes> => {
  return scmPost(provider, '/api/scm/branches', requesterToken.patToken, {
    organization: body.organization,
    project: body.project,
    repository: body.repositoryId,
  });
};

interface RequestBody {
  provider: ScmProviderId;
  body: {
    organization: string;
    project: string;
    repositoryId: string;
  };
  requesterToken: {
    patToken: string;
  };
}

export const useBranchDetail = ({ provider, body, requesterToken }: RequestBody) => {
  const res = useMutation({
    mutationFn: () => getBranchesDetails(provider, body, requesterToken),
  });

  return {
    branchData: res.data,
    branchPending: res.isPending,
    branchError: res.error,
    branchStatus: res.status,
    mutate: res.mutate,
  };
};
